// @Version: 1.0.1
import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-list',
  templateUrl: './nav-list.component.html',
  standalone: false
})
export class NavListComponent {
   constructor () {};

}
